import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FlexRow } from 'ui-components/components/flex/row';

// @ts-expect-error less import
import style from './style.module.less';

/**
 * @typedef {import('./compound-button-types.d.ts').CompoundButtonComponent} CompoundButtonComponent
 */

/**
 * @type {CompoundButtonComponent}
 */
export const CompoundButton = ({
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonMessage,
  secondaryButtonMessage,
  theme = 'primary',
}) => {
  return (
    <FlexRow className='button-group'>
      <Button onClick={onPrimaryButtonClick} theme={theme}>
        <FormattedMessage {...primaryButtonMessage} />
      </Button>
      <DropdownMenu closeWhenChildrenClicked={false} dropdownMenuClassName={style['dropdown-menu']} menuPosition='bottom-right'>
        <DropdownMenuToggler className={style['drop-down-menu-button']} theme={theme} />
        <DropdownMenuItem onClick={onSecondaryButtonClick}>
          <FormattedMessage {...secondaryButtonMessage} />
        </DropdownMenuItem>
      </DropdownMenu>
    </FlexRow>
  );
};
